import { InlineError, Input } from 'avo-ui'
import ModalForm from 'components/commons/modal-form'

export const FormUserMembership = ({
    show,
    onHideForm,
    dataUserMembership,
    isLoading,
    onChangeForm,
    errorForm,
    onSubmit,
}) => {
    return (
        <ModalForm
            className={'!w-[450px]'}
            classNameContent={'!max-h-[500px] overflow-auto'}
            show={show}
            onHide={onHideForm}
            title={'Create User Membership'}
            isLoading={isLoading}
            onSubmit={onSubmit}
        >
            <div className={'flex flex-col space-y-6 px-8 py-2 mb-2'}>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90 required'}>Nama</div>
                    <Input
                        className={'flex-1'}
                        name={'name'}
                        placeholder={'Masukkan nama'}
                        value={dataUserMembership?.name}
                        onChange={onChangeForm}
                    />
                    <InlineError className='mt-2' message={errorForm?.name} />
                </div>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90 required'}>Email</div>
                    <Input
                        className={'flex-1'}
                        name={'email'}
                        placeholder={'Masukkan email'}
                        value={dataUserMembership?.email}
                        onChange={onChangeForm}
                    />
                    <InlineError className='mt-2' message={errorForm?.email} />
                </div>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90 required'}>No. Telepon</div>
                    <Input
                        type={'tel'}
                        addonBefore={'+62'}
                        className={'flex-1'}
                        name={'phone_number'}
                        placeholder={'Masukkan no. telepon'}
                        maxLength={14}
                        value={dataUserMembership?.phone_number}
                        onChange={onChangeForm}
                    />
                    <InlineError className='mt-2' message={errorForm?.phone_number} />
                </div>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90'}>Total Point</div>
                    <Input
                        type={'number'}
                        className={'flex-1'}
                        name={'total_point'}
                        placeholder={'Masukkan total point'}
                        value={dataUserMembership?.total_point}
                        onChange={onChangeForm}
                    />
                    <InlineError className='mt-2' message={errorForm?.total_point} />
                </div>
            </div>
        </ModalForm>
    )
}
